import qs from 'qs'

const fields = [
  'names',
  'collectiveName',
  'annotation',
  'richText',
  'locale'
]

const populate = {
  images: true,
  nationalities: {
    fields: ['nationality']
  },
  muxAssets: {
    populate: true
  },
}

export const queryBiennialParticipantById = (options: queryOptions) => {
  const query = qs.stringify(
    {
      locale: options?.locale || 'en-US',
      status: options.status || 'published',
      filters: {
        $and: [
          {
            id: {
              $eq: options.id || options.slug
            }
          },
          {
            biennialEntries: {
              id: options?.filterId || undefined
            }
          }
        ]
      },
      pagination: {
        page: 1,
        pageSize: 1
      },
      fields,
      populate: {
        ...populate,
        localizations: {
          fields,
        },
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `biennial-participant-entries?${query}`
}
